import React, {FC} from 'react';
import {AutocompleteRenderGroupParams} from '@material-ui/lab';
import {withLocalization} from 'epic-localization/src/context/LocalizationContext';

import {StyledListSubheader} from './AutocompleteList.styles';
import {GroupName} from '../../pages/fortnite-games/useGamesData';

export const CODES = {
    [GroupName.TOP_GAMES]: 'epic.affiliate.fortnite_games.game_select.top_games',
    [GroupName.RECENTLY_PUBLISHED]: 'epic.affiliate.fortnite_games.game_select.recently_published',
    [GroupName.TOP_10_GAMES]: 'epic.affiliate.fortnite_games.game_select.my_top_10_games',
    [GroupName.TOP_10_TRENDING]: 'epic.affiliate.fortnite_games.game_select.my_top_10_trending'
};

export interface SubheaderProps extends AutocompleteRenderGroupParams {
    getMessage: (code: string) => string;
}

const Subheader: FC<SubheaderProps> = ({getMessage, ...params}: SubheaderProps) => {
    return (
        <StyledListSubheader key={params.key} component="div" disableSticky>
            {getMessage(CODES[params.group]) || params.group}
        </StyledListSubheader>
    );
};

export default withLocalization(Subheader);
